import { useRef, useCallback } from 'react';

// Global callback registry for sticky scroll
let globalStickyScrollCallback: (() => void) | null = null;

export const setGlobalStickyScrollCallback = (callback: (() => void) | null) => {
  globalStickyScrollCallback = callback;
  if (callback) {
    console.log('✅ Global sticky scroll callback registered');
  } else {
    console.log('❌ Global sticky scroll callback unregistered');
  }
};

export const getGlobalStickyScrollCallback = () => globalStickyScrollCallback;

// Hook to register a sticky scroll callback
export const useStickyScrollCallback = (callback: () => void) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const registerCallback = useCallback(() => {
    setGlobalStickyScrollCallback(() => callbackRef.current());
  }, []);

  const unregisterCallback = useCallback(() => {
    setGlobalStickyScrollCallback(null);
  }, []);

  return { registerCallback, unregisterCallback };
};
